import {
  SR_API_ACTION_AGENT_UPDATE_RENTER,
} from 'api/actionTypes';

export default async function saveViewingRenterSearchFilters({ state, apiClient }, { userId }) {
  const { viewingRenter, viewingRenterSearchFilters, viewingTour } = state.get(['agentMapView']);
  state.set(['agentMapView', 'listings'], []);
  await apiClient.postWithState({
    action: SR_API_ACTION_AGENT_UPDATE_RENTER,
    state: state,
    payload: {
      renterUpdates: {
        searchFilters: viewingRenterSearchFilters,
      },
      userId,
    },
    onSuccess() {
      state.set(['agentMapView', 'viewingRenter'], {
        ...viewingRenter,
        searchFilters: {
          ...viewingRenterSearchFilters,
        },
      });

      state.set(['agentMapView', 'listings'], viewingTour.listings);
    },
  });
}
